import { render, staticRenderFns } from "./stockAllocationAdd.vue?vue&type=template&id=58998e32&scoped=true&"
import script from "./stockAllocationAdd.vue?vue&type=script&lang=js&"
export * from "./stockAllocationAdd.vue?vue&type=script&lang=js&"
import style0 from "./stockAllocationAdd.vue?vue&type=style&index=0&id=58998e32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58998e32",
  null
  
)

export default component.exports